import { ISpecialPackageDto, ISpecialPackageRoomCategoryDto } from '../model';

export type SpecialPackageOccupancy = 1 | 2;

export function getAvailableSpecialPackageOccupancies(
  specialPackage: Pick<ISpecialPackageDto, 'priceOnePerson' | 'priceTwoPersons'>
): SpecialPackageOccupancy[] {
  const occupancies: SpecialPackageOccupancy[] = [];

  if (specialPackage.priceOnePerson !== null) {
    occupancies.push(1);
  }

  if (specialPackage.priceTwoPersons !== null) {
    occupancies.push(2);
  }

  return occupancies;
}

export function getDefaultSpecialPackageOccupancy(
  specialPackage: Pick<ISpecialPackageDto, 'priceOnePerson' | 'priceTwoPersons'>
): SpecialPackageOccupancy {
  return getAvailableSpecialPackageOccupancies(specialPackage)[0] ?? 1;
}

export function getSpecialPackagePriceForOccupancy(
  specialPackage: Pick<ISpecialPackageDto, 'priceOnePerson' | 'priceTwoPersons'>,
  occupancy?: number | null
): number | null {
  if (occupancy === 1) {
    return specialPackage.priceOnePerson;
  }

  if (occupancy === 2) {
    return specialPackage.priceTwoPersons;
  }

  return (
    specialPackage.priceOnePerson ??
    specialPackage.priceTwoPersons ??
    null
  );
}

export function getSpecialPackageRoomPriceForOccupancy(
  room: Pick<
    ISpecialPackageRoomCategoryDto,
    'priceOnePerson' | 'priceTwoPersons'
  >,
  occupancy?: number | null
): number | null {
  if (occupancy === 1) {
    return room.priceOnePerson;
  }

  if (occupancy === 2) {
    return room.priceTwoPersons;
  }

  return room.priceOnePerson ?? room.priceTwoPersons ?? null;
}

export function isSpecialPackageRoomSelectable(
  room: Pick<
    ISpecialPackageRoomCategoryDto,
    'priceOnePerson' | 'priceTwoPersons'
  >,
  occupancy?: number | null
): boolean {
  return getSpecialPackageRoomPriceForOccupancy(room, occupancy) !== null;
}

export function calculateSpecialPackageDeposit(
  totalPrice: number | null
): number | null {
  if (totalPrice === null) {
    return null;
  }

  const deposit = Math.ceil(totalPrice / 3 / 50) * 50;

  return deposit > totalPrice ? totalPrice : deposit;
}
